import { render, staticRenderFns } from "./TableServicesOcHes.vue?vue&type=template&id=621d6338"
import script from "./TableServicesOcHes.vue?vue&type=script&lang=js"
export * from "./TableServicesOcHes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports